import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check, Minus } from "lucide-react";
import { COMPARISON, PLANS, planToParams } from "@/data/content";

export default function Comparison() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("setup");
  const plan = tab === "setup" ? PLANS[0] : PLANS[1];

  return (
    <section className="bg-[#F5F7FC] border-y border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-6 py-24 grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
        {/* Comparison table */}
        <div className="rounded-2xl bg-white border border-[#E2E8F0] overflow-hidden" data-testid="comparison-table">
          <div className="flex items-center justify-between p-6">
            <div>
              <h3 className="font-display text-2xl tracking-tight uppercase">Radio App Consultancy vs. Others</h3>
              <p className="text-sm text-[#475569] mt-1">Why we're the smarter, one-time choice.</p>
            </div>
            <span className="text-[10px] font-bold uppercase tracking-wider bg-[#3B82F6]/10 text-[#3B82F6] px-3 py-1.5 rounded-full">Side-by-side</span>
          </div>
          <div className="grid grid-cols-[1fr_auto_auto] text-sm">
            <div className="contents">
              <div className="px-6 py-3 text-xs font-bold uppercase tracking-wider text-[#475569] border-t border-[#E2E8F0]">Feature</div>
              <div className="px-6 py-3 text-xs font-bold uppercase tracking-wider text-[#3B82F6] border-t border-[#E2E8F0] text-center">Radio App Consultancy</div>
              <div className="px-6 py-3 text-xs font-bold uppercase tracking-wider text-[#475569] border-t border-[#E2E8F0] text-center">Others</div>
            </div>
            {COMPARISON.map((row) => (
              <div key={row.feature} className="contents">
                <div className="px-6 py-4 border-t border-[#E2E8F0] text-[#0F172A]">{row.feature}</div>
                <div className="px-6 py-4 border-t border-[#E2E8F0] flex justify-center">
                  {row.savi ? <span className="h-6 w-6 rounded-full bg-[#3B82F6] flex items-center justify-center"><Check className="h-4 w-4 text-white" /></span> : <Minus className="h-4 w-4 text-[#C7CCDB]" />}
                </div>
                <div className="px-6 py-4 border-t border-[#E2E8F0] flex justify-center">
                  {row.others ? <span className="h-6 w-6 rounded-full bg-[#C7CCDB] flex items-center justify-center"><Check className="h-4 w-4 text-white" /></span> : <Minus className="h-4 w-4 text-[#C7CCDB]" />}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Pay less card */}
        <div className="rounded-2xl bg-[#26395F] text-white p-10" data-testid="pay-less-card">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#3B82F6]">Best Value</p>
          <h3 className="font-display text-2xl sm:text-3xl tracking-tight mt-3 uppercase">Pay once. Done right.</h3>
          <p className="text-white/70 mt-5 leading-relaxed">
            Pick the one-time service that fits — a complete <span className="text-white font-semibold">project setup &amp; kickoff</span>,
            or expert <span className="text-[#3B82F6] font-semibold">software consultation</span>. No subscription, ever.
          </p>

          <div className="mt-7 flex rounded-full bg-white/10 p-1 w-full max-w-sm">
            {[{ k: "setup", l: "Setup" }, { k: "consultancy", l: "Consultation" }].map((t) => (
              <button
                key={t.k}
                onClick={() => setTab(t.k)}
                className={`flex-1 py-2.5 rounded-full text-sm font-semibold transition-colors ${tab === t.k ? "bg-[#3B82F6] text-[#0F172A]" : "text-white/70 hover:text-white"}`}
                data-testid={`payless-tab-${t.k}`}
              >
                {t.l}
              </button>
            ))}
          </div>

          <div className="mt-6 flex items-end gap-2">
            <span className="font-display text-4xl">${plan.price}</span>
            <span className="text-[#3B82F6] text-sm font-semibold mb-2">one-time</span>
          </div>

          <button
            onClick={() => navigate(`/checkout${planToParams(plan)}`)}
            className="btn-sweep mt-8 bg-[#3B82F6] text-[#0F172A] font-bold px-8 py-3.5 rounded-full hover:glow-primary transition-shadow duration-300"
            data-testid="payless-cta"
          >
            {plan.cta}
          </button>
        </div>
      </div>
    </section>
  );
}
